import React, {useContext} from 'react';
import {TableDataContext} from '../../../Contexts/TableDataContext'
import DealValueInr from '../../RE/ReListCard/DealValueInr'
import DealValueUsd from '../../RE/ReListCard/DealValueUsd'
import InvestmentCard from '../../RE/ReListCard/InvestmentCard'
import AllDealCard from '../../RE/ReListCard/AllDealCard'

/**
 * The `Card` component renders four different cards based on the data received from the
 * `TableDataContext`.
 * @returns The Card component is returning a JSX element.
 */
 const Card = () => {
  const { data, isLoad, isDataLoad } = useContext(TableDataContext);
  return (
    <div className=""> 
      <div className='sm:mt-4 md:mt-12 h-full bg-[#F2F2F2]'>
        <div className="hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden scrollbar-remove" style={{scrollbarWidth: 'none'}}>
          <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:py-[0.7rem] md:min-w-max lg:contents">
           {/* ----card1----- */}
          <DealValueUsd data={data} isLoad={isLoad} isDataLoad={isDataLoad} />
          {/* ----card2----- */}
          <DealValueInr data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>
          {/* ----card3----- */}
          <InvestmentCard data={data} isLoad={isLoad} isDataLoad={isDataLoad}/> 
          {/* ----card4----- */}
          <AllDealCard data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>
          </div>
            </div>
        <div className='border-b-2 border-[#e5e5e5]'></div>
      </div >
    </div >
  )
}

export default Card;
